"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllSettled = promiseAllSettled;
const summarized_aggregate_error_1 = require("./summarized-aggregate-error");
async function promiseAllSettled(promises) {
    const errors = [];
    const results = await Promise.allSettled(promises);
    const resultValues = [];
    for (const result of results) {
        if (result.status === 'rejected') {
            errors.push(result.reason);
        }
        else if (result.status === 'fulfilled') {
            resultValues.push(result.value);
        }
    }
    if (errors.length > 0) {
        if (errors.length === 1) {
            throw errors[0];
        }
        throw new summarized_aggregate_error_1.SummarizedAggregateError(errors);
    }
    return resultValues;
}
//# sourceMappingURL=promise-all-settled.js.map